<form (keydown.enter)="$event.preventDefault()" [formGroup]="checkOutForm">
  <mat-card class="mat-elevation-z14">
    <mat-card-content>
      <h2 i18n="@@checkOut">Check Out</h2>

      <p i18n="@@checkOutGuidance">
        Please provide us the following information and touch the button below to check
        out.
      </p>

      <div>
        <mat-form-field>
          <input
            matInput
            formControlName="tag"
            name="tag"
            type="tel"
            placeholder="Badge #"
            i18n-placeholder="@@formLabelBadge"
            maxlength="8"
          />
          <mat-hint align="end"
            >{{ checkOutForm.get('tag').value.length || 0 }}/8</mat-hint
          >
        </mat-form-field>
      </div>

      <button
        id="check-out-btn"
        mat-raised-button
        [disabled]="checkOutForm.invalid || state.loading"
        (click)="save.emit(checkOutForm.value)"
        i18n="@@formCheckOutBtn"
      >
        CHECK OUT NOW
      </button>
    </mat-card-content>
  </mat-card>
</form>
